import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '@app-models/user';
import { Router } from '@angular/router';
import { yearsPerRow } from '@angular/material/datepicker';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private api: ApiService, private router: Router) {
    // Restore user from localStorage on page reload
    const storedUser = localStorage.getItem('currentUser');
    let user: User | null = null;

    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        // Convert plain object to User instance to restore proper typing
        if (userData && typeof userData === 'object') {
          user = new User();
          Object.assign(user, userData);
        }
      } catch (error) {
        console.error('Failed to parse stored user data:', error);
        // Clear corrupted data
        localStorage.removeItem('currentUser');
      }
    }

    this.currentUserSubject = new BehaviorSubject<User>(user);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public setCurrentUser(user: User): void {
    console.log('Setting user with ', user);
    this.currentUserSubject.next(user);
    // Ensure user is also persisted to localStorage
    if (user) {
      localStorage.setItem('currentUser', JSON.stringify(user));
    } else {
      localStorage.removeItem('currentUser');
    }
  }

  isLoggedIn(): boolean {
    const user = this.currentUserSubject.value;
    return user && user.id !== null;
  }

  login(loginData): any {
    return this.api.post('login', loginData).pipe(
      map((resp: any) => {
        const user = new User();
        user.id = resp.user_id;
        user.token = resp.token;
        user.login = loginData.login;
        user.displayName = resp.display_name;
        const decoded = JSON.parse(window.atob(resp.token.split('.')[1]));
        console.log(decoded);
        user.expiredAt = decoded.exp;
        user.email = resp.email;
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.setCurrentUser(user);
        return resp;
      })
    );
  }

  logout(): void {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    this.router.navigate(['/auth/login']);
  }
}

